import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { usePlacesWidget } from "react-google-autocomplete";
import DatePicker from "react-datepicker";
import React from "react";
import he from "date-fns/locale/he";
import { format } from "date-fns";
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
const WhereAndWhen = ({
  onChange,
  handleOnPlaceSelected,
  onDateChange,
  moveDate,
}) => {
  const { ref: fromRef } = usePlacesWidget({
    apiKey: GOOGLE_API_KEY,
    onPlaceSelected: (place, inputRefFrom) =>
      handleOnPlaceSelected(place, inputRefFrom),
    options: {
      types: ["address"],
      componentRestrictions: { country: "il" },
    },
  });

  const { ref: toRef } = usePlacesWidget({
    apiKey: GOOGLE_API_KEY,
    onPlaceSelected: (place, inputRefTo) =>
      handleOnPlaceSelected(place, inputRefTo),
    options: {
      types: ["address"],
      componentRestrictions: { country: "il" },
    },
  });
  return (
    <>
      <Row className="mb-3 row ">
        <Form.Group as={Col} className="mb-3" controlId="formBasicFrom">
          <Form.Label className="fw-semibold mb-2">מהיכן?</Form.Label>
          <Form.Control
            type="text"
            placeholder="ישוב מוצא"
            name="fromaddress"
            onChange={onChange}
            required
            ref={fromRef}
          />
          <Form.Control.Feedback type="invalid">
            נא להכניס ישוב מוצא
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3 row">
        <Form.Group as={Col} className="mb-3" controlId="formBasicDestination">
          <Form.Label className="fw-semibold mb-2">להיכן?</Form.Label>
          <Form.Control
            type="text"
            placeholder="ישוב יעד"
            name="toaddress"
            onChange={onChange}
            required
            ref={toRef}
          />
          <Form.Control.Feedback type="invalid">
            נא להכניס ישוב יעד
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3 row">
        <Form.Group as={Col} className="mb-3" controlId="formBasicDate">
          <Form.Label className="fw-semibold mb-2">מתי?</Form.Label>

          <DatePicker
            name="storageDateFrom"
            dateFormat="dd/MM/yyyy"
            placeholderText="בחר תאריך"
            minDate={new Date()}
            selected={moveDate ? new Date(moveDate) : ""}
            onChange={(date) =>
              onDateChange(format(date, "yyyy-MM-dd"), "date")
            }
            customInput={
              <Form.Control
                readOnly
                autoComplete="off"
                autoCorrect="off"
                name="storageDateFrom"
              />
            }
            locale={he}
            required
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default WhereAndWhen;
